import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from '../../../../../../../core/shared/widget/widget-data';
import {FilterCriteria} from '../../../../../../../core/shared/filter/api/filter.criteria';
import {WidgetFactory} from '../../../../../../../core/shared/widget/service/widget.factory';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../../../../../core/shared/helper/widget-function-call-back-create';

@Component({
    selector: 'bm-billing-area-billing-run-types',
    templateUrl: 'bm-billing-area-billing-run-types.component.html',
    standalone: false
})
export class BmBillingAreaBillingRunTypesComponent implements OnInit, OnChanges, OnDestroy {

    initialized: boolean = false;

    @Input() billingAreaId: number;

    billingRunTypesWidgetData: WidgetData;

    ngOnInit(): void {
        this.refreshComponent();
    }

    refreshComponent() {
        const filterCriteria = FilterCriteria.create(
            'e.billingAreaId',
            FilterCriteria.cOperatorEqual,
            this.billingAreaId
        );

        this.billingRunTypesWidgetData = WidgetFactory.createWidgetTableEntityBasicQl(
            `bm.billing.area.billing.run.types.widget.data.${this.billingAreaId}`,
            'Abrechnungslauftypen',
            'bm.BillingRunType',
            [filterCriteria]
        );

        const fields: WidgetToolbarCreateInterface[] = [
            {fieldName: 'billingAreaDtoId', fieldValue: this.billingAreaId}
        ];
        this.billingRunTypesWidgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        if (changes['billingAreaId']) {
            this.refreshComponent();
        }
    }

    ngOnDestroy(): void {
    }
}
